// Tiny client-side bus + buffer for pipeline-run narration.
// RunPipelineButton emits; ChatPanel and the activity-log modal read.
// The module-level buffer survives client-side route changes (React tree
// re-mounts, but JS modules stay live), so navigating between stages keeps
// the running narration intact.

// `view` lets the producer attach a structured payload that the consumer
// (ChatPanel) can render as a custom widget instead of plain markdown —
// today, only the FTW agent live-session card.
export type RunProgressView = {
  kind: 'live_session';
  session_id: string;
  stage_key: string;
};

export type RunProgressEvent = {
  agent: string;
  body: string;
  ts: number;
  view?: RunProgressView;
};

const EVENT_NAME = 'matilda-run-progress';
const CLEAR_EVENT = 'matilda-run-progress-clear';

const buffer: RunProgressEvent[] = [];

export function emitRunProgress(detail: { agent: string; body: string; view?: RunProgressView }): void {
  const event: RunProgressEvent = { ...detail, ts: Date.now() };
  buffer.push(event);
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: event }));
}

export function getRunProgressBuffer(): RunProgressEvent[] {
  return buffer.slice();
}

export function clearRunProgress(): void {
  buffer.length = 0;
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(CLEAR_EVENT));
}

export function subscribeRunProgress(cb: (e: RunProgressEvent) => void): () => void {
  if (typeof window === 'undefined') return () => {};
  const handler = (e: Event): void => {
    const ce = e as CustomEvent<RunProgressEvent>;
    cb(ce.detail);
  };
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
}

export function subscribeRunProgressClear(cb: () => void): () => void {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(CLEAR_EVENT, cb);
  return () => window.removeEventListener(CLEAR_EVENT, cb);
}
